import { ResponseMessage } from './ResponseMessage';

export class AbstractResponse {
  public responseMessages: ResponseMessage[] = [];

  constructor() {}
}
